class SliderComposite {
    constructor(name, items) {
        this.name = name;

        this.items=items;
    }
}

export default SliderComposite;